// extracted by mini-css-extract-plugin
export default {"loading-icon":"mgENv","loadingIcon":"mgENv","loading-opacity":"_3wUZi","loadingOpacity":"_3wUZi"};